import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { authorsApi } from "./authorsApi";

export const useAuthors = () => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.BLOG_AUTHORS(),
    queryFn: () => authorsApi.fetchAuthors(),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.BLOG_AUTHORS(),
    });
  };

  return {
    isLoading,
    isFetching,
    authors: data?.data ?? [],
    invalidate,
  };
};
